import { RedoProgressBar } from "@redotech/arbiter/progress-bar/redo-progress-bar";
import { memo } from "react";
import type { OverallProgress } from "../../registry/types";

export interface WidgetProgressBarProps {
  progress: OverallProgress;
}

/**
 * Compute the rounded 0–100 percentage from progress numerator/denominator.
 * Returns 0 when total is 0 (avoids divide-by-zero). Exported for unit tests
 * so we don't need a render to verify the rule.
 */
export function computeProgressPercentage(
  complete: number,
  total: number,
): number {
  if (total === 0) {
    return 0;
  }
  return Math.round((complete / total) * 100);
}

/** Thin progress bar — no count text, just the visual fill. */
export const WidgetProgressBar = memo(function WidgetProgressBar({
  progress,
}: WidgetProgressBarProps) {
  const percentage = computeProgressPercentage(
    progress.complete,
    progress.total,
  );
  return (
    <RedoProgressBar labelStyle="none" percentage={percentage} style="thin" />
  );
});
